const IconService = class IconService {
  constructor () {
    'ngInject'
  }
}
export default IconService
